// src/utils/cartDisplay.ts
//
// Helpers for rendering a cart line item whose `.space` may be a real
// AdSpace (from the internal /brand flow) or a BrandListing wrapped as one
// (from the public landing flow — see ListingCard.tsx / ListingDetailPage.tsx).
// The two have different pricing/photo field names, so these read both
// shapes defensively instead of assuming one.

export interface DisplayListing {
  id: string;
  title?: string;
  area?: string;
  city?: string;
  state?: string;
  mediaType?: string;
  // BrandListing shape
  photos?: string[];
  priceBreakdown?: { totalPayable: number };
  // AdSpace shape
  images?: string[];
  rentAmount?: number;
  commission?: number;
  gst?: number;
}

export function getListingTotal(listing: DisplayListing | undefined | null): number {
  if (!listing) return 0;
  if (typeof listing.priceBreakdown?.totalPayable === "number") {
    return listing.priceBreakdown.totalPayable;
  }
  if (typeof listing.rentAmount === "number") {
    const base = listing.rentAmount + (listing.commission ?? 0);
    const gstAmount = Math.round((base * (listing.gst ?? 0)) / 100);
    return base + gstAmount;
  }
  return 0;
}

export function getListingPhotos(listing: DisplayListing | undefined | null): string[] {
  if (!listing) return [];
  return listing.photos ?? listing.images ?? [];
}